import { type FC } from 'react';
import { useTranslation } from 'react-i18next';

import { AgentChatLogo } from '@/components/agent-chat-logo';

import './prop-chat-initial-state.css';

export const PropChatInitialState: FC = () => {
  const { t } = useTranslation();

  return (
    <div className="flex h-full w-full items-center justify-center bg-[var(--ds-color-bg-primary)] px-[var(--ds-space-6)] py-[var(--ds-space-4)]">
      <div className="flex w-full flex-col items-center gap-[var(--ds-space-2)] text-center">
        <div className="flex w-full flex-col items-center gap-[var(--ds-space-4)]">
          <AgentChatLogo className="prop-chat-initial-logo size-[var(--ds-space-10)]" />
          <h2 className="font-[var(--ds-typography-font-definitions-font-family-body)] text-[length:var(--ds-typography-paragraph-large-font-size)] font-[var(--ds-typography-paragraph-paragraph-medium-weight)] leading-[var(--ds-typography-paragraph-large-line-height)] tracking-[var(--ds-typography-paragraph-large-letter-spacing)] text-[var(--ds-color-text-primary)]">
            {t('prop-chat.initial-title')}
          </h2>
        </div>
        <div className="flex w-full flex-col gap-[var(--ds-space-4)] text-[var(--ds-color-text-secondary)]">
          <p className="font-[var(--ds-typography-font-definitions-font-family-body)] text-[length:var(--ds-typography-paragraph-regular-font-size)] font-[var(--ds-typography-paragraph-paragraph-weight)] leading-[var(--ds-typography-paragraph-regular-line-height)] tracking-[var(--ds-typography-paragraph-regular-letter-spacing)]">
            {t('prop-chat.initial-description')}
          </p>
          <ul className="w-full list-inside list-disc font-[var(--ds-typography-font-definitions-font-family-body)] text-[length:var(--ds-typography-paragraph-small-font-size)] font-[var(--ds-typography-paragraph-paragraph-weight)] leading-[var(--ds-typography-paragraph-small-line-height)] tracking-[var(--ds-typography-paragraph-small-letter-spacing)]">
            <li>{t('prop-chat.initial-capability-summary')}</li>
            <li>{t('prop-chat.initial-capability-documents')}</li>
            <li>{t('prop-chat.initial-capability-explanation')}</li>
          </ul>
        </div>
      </div>
    </div>
  );
};
